import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  newSubsectionButton: {
    id: 'course-authoring.course-outline.section.button.new-subsection',
    defaultMessage: 'New subsection',
  },
  sectionHighlightsBadge: {
    id: 'course-authoring.course-outline.section.badge.section-highlights',
    defaultMessage: 'Section highlights',
  },
});

export default messages;
